import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { ApiService } from 'src/app/_core/_services/api.service';
import {
  NetworkServices,
  NetworkSeviceActions,
  ServiceCreationRequest
} from '../_models/network-services.model';

@Injectable({
  providedIn: 'root'
})
export class NetworkServicesService {
  constructor(private api: ApiService) {}

  getNetworkServices(queryParams?: any) {
    if (queryParams) {
      queryParams = {
        ...queryParams
      };
    } else {
      queryParams = {
        limit: 100,
        offset: 0,
        q: '',
        filter: []
      };
    }

    return this.api.getAPI('network-portal/services', queryParams).pipe(
      map((res: any) => {
        return res.body;
      })
    );
  }

  createNetworkService(data: ServiceCreationRequest) {
    return this.api.postAPI(`network-portal/services/create`, data);
  }

  regradeNetworkService(data: NetworkSeviceActions, service_id: string) {
    return this.api.postAPI(`network-portal/services/${service_id}/regrade`, data);
  }

  suspendNetworkService(data: NetworkSeviceActions, service_id: string) {
    return this.api.postAPI(`network-portal/services/${service_id}/suspend`, data);
  }

  activateNetworkService(data: NetworkSeviceActions, service_id: string) {
    return this.api.postAPI(`network-portal/services/${service_id}/activate`, data);
  }

  cancelNetworkService(data: NetworkSeviceActions, service_id: string) {
    return this.api.postAPI(`network-portal/services/${service_id}/cancel`, data);
  }

  modifyNetworkService(data: NetworkSeviceActions, service_id: string) {
    return this.api.postAPI(`network-portal/services/${service_id}/modify`, data);
  }

  modifyNetworkDevice(data: NetworkSeviceActions, service_id: string) {
    return this.api.postAPI(`network-portal/services/device-modification`, data);
  }

  // Missing methods that were referenced in components
  createServiceRequest(data: any): Observable<any> {
    return this.api.postAPI('network-portal/services/requests', data).pipe(
      map((res: any) => {
        return res.body;
      })
    );
  }

  getServiceTimeline(serviceId: string): Observable<any> {
    return this.api.getAPI(`network-portal/services/${serviceId}/timeline`).pipe(
      map((res: any) => {
        return res.body;
      })
    );
  }

  getServiceRequests(queryParams?: any): Observable<any> {
    return this.api.getAPI('network-portal/services/requests', queryParams).pipe(
      map((res: any) => {
        return res.body;
      })
    );
  }
}
